// @ts-ignore
import Headroom from 'headroom.js'
export default function init() {
  const headerEl = document.querySelector('header');
  if (headerEl) {
    const headroom = new Headroom(headerEl, {offset: 40});
    headroom.init();
  }
}